import React from 'react';

const statusProgressMap = {
    Pending: { value: 0, color: '#B0BEC5' },         // Light Grey
    Processing: { value: 20, color: '#FF9800' },     // Medium Orange
    Ready: { value: 40, color: '#FFC107' },          // Warm Amber
    'Picked Up': { value: 60, color: '#03A9F4' },      // Sky Blue
    'Out For Delivery': { value: 80, color: '#3F51B5' }, // Royal Blue
    Delivered: { value: 100, color: '#4CAF50' }      // Emerald Green
  };

const statusIcons = {
  Pending: 'pi pi-clock',
  Processing: 'pi pi-cog',
  Ready: 'pi pi-check-circle',
  'Picked Up': 'pi pi-box',
  'Out For Delivery': 'pi pi-truck',
  Delivered: 'pi pi-flag'
};

const OrderSteps = ({ currentStatus }) => {
  const statuses = Object.keys(statusProgressMap);
  const activeIndex = statuses.indexOf(currentStatus);
  const currentColor = statusProgressMap[currentStatus]?.color || '#000';

  return (
    <div className="custom-progress-container">
      <h4 className="title-2">
        Order Status:{' '}
        <span style={{ color: currentColor }}>{currentStatus}</span>
      </h4>
      <div className="p-steps">
        {statuses.map((label, index) => {
          const isActive = index === activeIndex;
          const isCompleted = index < activeIndex;
          const iconClass = statusIcons[label];
          const color = statusProgressMap[label]?.color || '#ccc';

          return (
            <div 
              key={label}
              className={`p-steps-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            >
              <div
                className="custom-icon-wrapper"
                style={{
                  backgroundColor: isCompleted || isActive ? color : '#eee',
                  color: isCompleted || isActive ? '#fff' : '#999'
                }}
              >
                <i className={iconClass} />
              </div>
              <span className="p-steps-title">
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderSteps;
